import {
  Component,
  OnInit
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  ParamMap
} from '@angular/router';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  NgForm
} from '@angular/forms';
import {
  ApiPartnerService
} from '@app/api/api-partner.service';


@Component({
  selector: 'app-adminpartner-notif',
  templateUrl: './adminpartner-notif.component.html',
  styleUrls: ['./adminpartner.component.css']
})
export class AdminpartnerNotifComponent implements OnInit {

  textSearch = new FormControl('');
  workorderList: any = {};
  ServiceList: any = [];
  ViewSTB: any = {};
  paging: any = {};
  Billingtype: any = [];
  Servicetype: any = [];

  daynotif: any = [];

  fs: string;
  msearch: string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href = '';
  alert_act = '';
  alert_actmsg = '';

  isOne = false;
  alert_failed = false
  alert_success = false


  Notiflist: any = [];
  NotiflistData: any = [];

  formPost = this.fb.group({
    search: [''],
    sts: [''],
    searchtype: [''],
    next: [0]
  })


  table_load = true
  nextbtn = false
  loadnext = false
  loadmax = false

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.loadStart();
  }


  loadStart() {
    this.loadService(this.formPost.value)
  }

  refreshPage() {
    this.clearFirst()
    this.ngOnInit()
  }

  clearFirst() {
    this.NotiflistData = []
    this.formPost.get('searchtype').setValue(undefined)
    this.formPost.get('sts').setValue(undefined)
    this.formPost.get('search').setValue('')
    this.formPost.get('next').setValue(0)
  }
  falsed() {
    this.table_load = false
    this.loadnext = false
  }

  search() {
    this.table_load = true
    this.NotiflistData = []
    this.formPost.get('next').setValue(0)
    this.loadService(this.formPost.value);
  }
  next() {
    this.nextbtn = false
    this.loadnext = true
    this.loadService(this.formPost.value);
  }

  // Issues list
  loadService(data: any) {
    this.table_load = true;
    return this.partnerService.Getpartnernotification(data).subscribe((output: any) => {
      console.log(output);
    //   this.ServiceList = output.data;
    //   this.table_load = false


	this.Notiflist = output.data;
	this.total_count = output.count

	this.Notiflist.forEach((row:any) => {
	  
	  this.NotiflistData.push(row);
	});

	this.formPost.get('next').setValue(output.next)
	this.falsed()

	if(this.Notiflist.length < 10){
	  this.nextbtn = false
	  this.loadmax = true
	}else{
	  this.nextbtn = true
	  this.loadmax = false

	}



	

	// console.log(this.paging);
	//this.paging_link = this.ServiceList.paging.links;
    })
  }

  isnullnotif(item) {
    if (!item.notif) {
      return true;
    } else {
      return false;
    }
  }

  iscronactive(item, code) {
    if (item[code] == null) {
      return false;
    }

    if (item[code]['statuscron'] == 1) {
      return false;
    } else {
      return true;
    }
  }

  //notif reminder
  addCronNotif(item, notifcode, i) {

    let notif = this.getNotifByCode(item, notifcode);
    let actiondate = '';
    let notifid = 0;
    let code = '';
    if (notif == null) {
      actiondate = '';

    } else {
      actiondate = notif['actiondate'];
      notifid = notif['id'];
      code = notif['notifcode'];
    }


    let params = {
      "notifcode": code,
      "customerid": item.customerid,
      "notiftype": "reminder",
      "actiondate": actiondate,
      "customerserviceid": item.customerserviceid,
      "notifid": notifid
    };

    return this.partnerService.PostAddCronNotification(params).subscribe((output: any) => {
      console.log(output);
      alert('ok');
    });


  }

  addNotif(item, code, i) {
    let params = {
      "notifcode": code,
      "customerid": item.customerid,
      "notiftype": "reminder",
      "customerserviceid": item.customerserviceid
    };

    return this.partnerService.PostAddNotification(params).subscribe((output: any) => {
      console.log(output);
      if (output['data'][item.customerserviceid]['-5'] != undefined) {
        this.ServiceList[i]['notif5'] = output['data'][item.customerserviceid]['-5'];
      }

      if (output['data'][item.customerserviceid]['-5'] != undefined) {
        this.ServiceList[i]['notif10'] = output['data'][item.customerserviceid]['-10'];
      }
      if (output['data'][item.customerserviceid]['-5'] != undefined) {
        this.ServiceList[i]['notif15'] = output['data'][item.customerserviceid]['-15'];
      }

    })
  }



  getNotif5(item) {
    if (item.notif5 == null) {
      return '0000-00-00';
    } else {
      return item.notif5.actiondate;
    }
  }

  getNotif10(item) {
    if (item.notif10 == null) {
      return '0000-00-00';
    } else {
      return item.notif10.actiondate;
    }
  }

  getNotif15(item) {
    if (item.notif15 == null) {
      return '0000-00-00';
    } else {
      return item.notif15.actiondate;
    }
  }

  getNotifByCode(item, notifcode) {
    return item[notifcode];
  }

  SentNotif(item) {
    if (!confirm('Yakin mengirim notif ke pelanggan ?')) {
      return;
    }

    let params = {
      id: item.customerserviceid
    };

    return this.partnerService.PostSendNotification(params).subscribe((output: any) => {
      console.log(output);

    });
  }

  availableNotif(item) {
    return (parseInt(item.berakhir) < 0);
  }


  setcronnotif(item, i) {
    if (!confirm('Add Notifikasi di ' + this.daynotif[item.customerserviceid] + ' ? ')) {
      return;
    }

    this.addNotif(item, this.daynotif[item.customerserviceid], i);
  }

  showcontent(item) {
    if (item.cronnotif) {
      return item.cronnotif['content'];
    } else {
      return '';
    }
  }


}
